// Δ спрямо предходния период — една сметка за целия модул „Справки".

/**
 * Процентна разлика спрямо предходния период.
 *
 * `null` = делтата няма смисъл и НЕ бива да се рисува: предходният период е
 * нула, а текущият не е (ръст от нищо не е „+100 %", а „ново"). Нула срещу
 * нула е честна нула.
 */
export const deltaPercent = (
  current: number,
  previous: number,
): number | null => {
  if (!Number.isFinite(current) || !Number.isFinite(previous)) return null;
  if (previous === 0) return current === 0 ? 0 : null;
  return ((current - previous) / Math.abs(previous)) * 100;
};
